// @flow
import {connect} from 'react-redux';
import Integrations from '../components/Integrations';

import type {RootState} from '../../../modules';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    dueInformation: state.tiersList.dueInformation,
  }),
  null
)(Integrations);
